module.exports = "https://www.niulinkcloud.cn/_next/static/media/pcBanner1.7aa11651eb99bedfea976a96b59e9a5b.jpg";